<template>
  <v-container>
    <v-autocomplete chips filled multiple rounded clearable deletable-chips solo v-model="values" :items="diagTypes"
      class="ma-4" @change="hasChanged()" @reset="reset()"></v-autocomplete>
    <v-btn @click="send" class="ma-5"> send getdiag </v-btn>
  </v-container>
</template>

<script>
const diagTypes = {
  ALL: "ALL",
  MASTER_XBEE: "MASTER_XBEE",
  ENERGY_CARD: "ENERGY_CARD",
  TPA: "TPA",
  COLOR_SENSOR: "COLOR_SENSOR",
  MODEM: "MODEM",
  PRINTER: "PRINTER",
  LOCK_CARD: "LOCK_CARD",
};
export default {
  data: () => ({
    diagTypes: Object.keys(diagTypes),
    dataToSend: null,
    values: []
  }),
  methods: {
    send: function () {
      this.$emit('sendGetDiag', this.values);
    },
    hasChanged: function () {
      if (this.values.includes(diagTypes.ALL)) {
        this.selectAll();
      } else {
        this.reset();
      }
    },
    selectAll: function () {
      let tmp = this.diagTypes;
      tmp.shift();
      this.values = tmp;
    },
    reset: function () {
      this.diagTypes = Object.keys(diagTypes);
    }
  }
};
</script>